.da{aspect-ratio:1/1;}